'use strict';

import {ferry} from '../../../services/ferry/ferry';

export default ['$scope','$routeParams', function($scope, $routeParams) {
    $scope.resetDisabled = function() { return $scope.password == null || $scope.password.length < 1; };

    ferry.sessionless_performset('account.resetCheck', [$routeParams.code]).then(function(x){
        if (x[0].used) { // Check if code is already used
            document.location.href="/login";
        }
        else {
            $scope.email = x[0].email;
        }
        $scope.$apply();
    });

    $scope.doReset = function() {
        $scope.resetDisabled = function() { return true; };
        ferry.sessionless_perform('account.do_password_reset', [ $routeParams.code, $scope.password ]).then(function(success) {
            if (success) {
                document.location.href = '/login';
            }
        }).catch(function(x) {
            $scope.fed = "There was an error. Please try again later.";
        });
    };
}];



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/password/passwordReset.js